import React, {JSX} from 'react';
import { Container, Row, Col, Card } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    faCheckCircle,
    faGlobe,
    faBolt,
    faChartBar,
    faPlug
} from '@fortawesome/free-solid-svg-icons';
import { motion } from 'framer-motion';


interface Feature {
    icon: JSX.Element;
    title: string;
    text: string;
    bg: string;
}

const features: Feature[] = [
    {
        icon: <FontAwesomeIcon icon={faCheckCircle} style={{ color: '#1B1C4E' }} />,
        title: 'High Accuracy',
        text: 'Transcribe audio with exceptional precision and reliability.',
        bg: "#F5F5F7",
    },
    {
        icon: <FontAwesomeIcon icon={faGlobe} style={{ color: '#E83843' }} />,
        title: 'Multi-Language Support',
        text: 'Supports transcription in multiple languages seamlessly.',
        bg: "#FEF7F7",
    },
    {
        icon: <FontAwesomeIcon icon={faBolt} style={{ color: '#DE7244' }} />,
        title: 'Instant Summaries',
        text: 'Generate concise summaries from long conversations instantly.',
        bg: "#FFF9F6",
    },
    {
        icon: <FontAwesomeIcon icon={faChartBar} style={{ color: '#31B5A1' }} />,
        title: 'Executive Summary Dashboard',
        text: 'Visualize and access key insights through a powerful dashboard.',
        bg: "#F3FEFD",
    },
    {
        icon: <FontAwesomeIcon icon={faPlug} style={{ color: '#E7B96B' }} />,
        title: 'API Integration',
        text: 'Easily integrate transcription services into your workflows via API.',
        bg: "#FFFBF4",
    },
];

const cardVariants = {
    hidden: { opacity: 0, y: 40 },
    visible: (i: number) => ({
        opacity: 1,
        y: 0,
        transition: {
            delay: i * 0.2,
            duration: 0.6,
            ease: 'easeOut'
        }
    })
};

const Features: React.FC = () => {
    return (
        <section
            className="py-5 mt-4"
            style={{
                backgroundImage: 'url(Features-background.jpg)',
                backgroundSize: 'cover',
                backgroundPosition: 'center center',
                backgroundAttachment: 'fixed',
            }}
        >
            <Container>
                <motion.h2
                    className="text-center mb-5"
                    initial={{ opacity: 0, y: -20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 1 }}
                >
                    Why Choose Us?
                </motion.h2>

                <Row className="g-4 justify-content-center">
                    {features.map((feature, index) => (
                        <Col key={index} xs={12} sm={6} md={4} className="d-flex">
                            <motion.div
                                custom={index}
                                initial="hidden"
                                whileInView="visible"
                                viewport={{ once: true, amount: 0.3 }}
                                variants={cardVariants}
                            >
                                <Card className="h-100 w-100 border-0 shadow-sm p-4" style={{ backgroundColor: feature.bg }}>
                                    <Card.Body className="d-flex flex-column">
                                        <div className="d-flex align-items-center mb-2">
                                            <div className="me-2">
                                                {feature.icon}
                                            </div>
                                            <Card.Title className="mb-0">{feature.title}</Card.Title>
                                        </div>
                                        <Card.Text>{feature.text}</Card.Text>
                                    </Card.Body>
                                </Card>
                            </motion.div>
                        </Col>
                    ))}
                </Row>
            </Container>
        </section>
    );
};

export default Features;
